import React from 'react';

const LeadPositionPatternTab = ({ className }) => {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" width="100%" height="100%" viewBox="0 0 743 881" fill="none">
      <circle opacity="0.18" cx="711" cy="35" r="26" fill="#DDCAEB" stroke="#7F4A9B" stroke-width="10" />
      <circle opacity="0.35" cx="639" cy="86" r="20" fill="#DDCAEB" />
      <circle opacity="0.35" cx="157" cy="609" r="20" fill="#DDCAEB" />
      <circle opacity="0.35" cx="240" cy="556" r="20" fill="#DDCAEB" />
      <path opacity="0.29" d="M0 254C175 325.5 249 125 162.5 41L122 0H0V254Z" fill="#A971C7" />
      <path opacity="0.2" d="M742.404 792.536C646.25 685.474 493.969 765.991 513.752 880.133L742.404 880.133L742.404 792.536Z" fill="#7F4A9B" />
      <path opacity="0.29" d="M742.404 655.39C581.382 592.125 513.292 769.531 592.883 843.855L630.148 880.133L742.404 880.133L742.404 655.39Z" fill="#A971C7" />
    </svg>
  );
};

export default LeadPositionPatternTab;